//angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//local
import { SecurityConfig } from '@app/core';
import { ApiConstants, HttpResult, PollyHttpHelper } from '@app/shared';
import { ProgramPropertyDto, CreateProgramRequest, UpdateProgramRequest } from '@app/catalog';

@Injectable({
    providedIn: 'root'
})
export class ProgramHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }


    public getProperties(programId: string): HttpResult<ProgramPropertyDto> 
    {
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/program/${programId}`;
            
      console.log(`GET: ${serviceUri}`);
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<ProgramPropertyDto>(serviceUri, { headers: ApiConstants.DefaultHeaders }));
    }

    public create(request: CreateProgramRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/program`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }

    public update(programId: string, request: UpdateProgramRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/program/${programId}`;
            
      console.log(`PUT: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('PUT', () => this.http.put<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }
}